import { Component, OnInit, ViewChild } from '@angular/core';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';

@Component({
  selector: 'app-reportbynotify',
  templateUrl: './reportbynotify.component.html',
  styleUrls: ['./reportbynotify.component.css']
})
export class ReportbynotifyComponent implements OnInit {

  user:any;
  constructor(private auth:Authenticationservice) {
    this.user = this.auth.Authention();
   }

  ngOnInit(): void {
    this.LoadErrplant();
  }

  @ViewChild('btable', {static:false}) erTable:any;
  erplant:any;
  LoadErrplant(){
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?supcode=%27"+this.user.supcode+"%27&canetype=%27ER%27&growed1=%27P%27";
    axios.get(url)
    .then(res => {
     this.erplant =  (res.data.recordset).sort((a:any, b:any) => b.insertDateDiff - a.insertDateDiff);
     setTimeout(() => {
     $(this.erTable.nativeElement).DataTable();
     }, 1500);
    }).catch(err => { throw err})
  }

}
